// @flow

import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import type { InjectIntlProvidedProps } from 'react-intl';

import RadioGroup from '../../../components/RadioGroupDayPicker';

type Props = InjectIntlProvidedProps & {
  selectedFrom: Date | null,
  selectedTo: Date | null,
  subscriptionIsActive: boolean,
  premiumPlan?: boolean,
  isMonthsPresets?: boolean,
  datePresets: Array<{
    periodDays: number,
    fromDate: Date,
    toDate: Date,
  }>,
  onChange: (fromDate: Date, toDate: Date) => any,
};

const messages = defineMessages({
  daysText: {
    id: 'filters.days',
    defaultMessage: '{value} дней',
  },
});

const Period = (props: Props) => {
  let disabled = !props.subscriptionIsActive;
  if (typeof props.premiumPlan !== 'undefined') {
    !props.premiumPlan && (disabled = true);
  }
  const { formatMessage } = props.intl;

  const periods = props.datePresets.map(preset => {
    const label = formatMessage(messages.daysText, {
      value: preset.periodDays,
    });
    const fromDate = preset.fromDate;
    const toDate = preset.toDate;
    return {
      label: props.isMonthsPresets ? preset.periodMonth : label,
      fromDate,
      toDate,
      disabled,
    };
  });

  return (
    <RadioGroup
      name="periodDays"
      selectedFrom={props.selectedFrom}
      selectedTo={props.selectedTo}
      options={periods}
      onChange={props.onChange}
    />
  );
};

export default injectIntl(Period);



// WEBPACK FOOTER //
// ./src/buisness/CommonFilters/components/Period.js